import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { useStore } from "../../../../utils/useStore";
import AcxDataGrid from "../../../UI/AcxDataGrid/AcxDataGrid";
import { AgentCoachingStore } from "../Stores/AgentCoachingStore";

const AgentsCoachingTable: FunctionComponent = observer(() => {
    const store = useStore(AgentCoachingStore);

    return (
        <Grid container item xs={12} height={"49vh"}>
            <AcxDataGrid dataGridStore={store.dgStore} />
        </Grid>
    );
});

export default AgentsCoachingTable;
